export function normalizeListFilterValue(v) {
  if (v == null || v === '') {
    return '';
  }
  return String(v).trim();
}

export function employeeListPayloadMatchesFilters(payload, filters) {
  if (!payload || !filters) {
    return false;
  }
  return (
    normalizeListFilterValue(payload.department) ===
      normalizeListFilterValue(filters.department) &&
    normalizeListFilterValue(payload.companyCode) ===
      normalizeListFilterValue(filters.companyCode) &&
    normalizeListFilterValue(payload.location) ===
      normalizeListFilterValue(filters.location) &&
    normalizeListFilterValue(payload.manager) ===
      normalizeListFilterValue(filters.manager) &&
    normalizeListFilterValue(payload.classification) ===
      normalizeListFilterValue(filters.classification)
  );
}
